<div class="mt-5 container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row my-3">
        <div class="col-sm-12 text-right">আইটি-১০ বিবি (২০২৩)</div>               
    </div>
    <div class="row my-3">
        <div class="col-sm-12 text-center font-weight-bold">
            <div>জীবনযাপন সংশ্লিষ্ট ব্যয়ের বিবরণী</div>
            <div>(স্বাভাবিক ব্যক্তিশ্রেণীর সকল করদাতার ক্ষেত্রে প্রযোজ্য)</div>
        </div>        
    </div>
    <div class="row my-5">
        <div class="col-sm-5">করদাতার নাম: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            টি আইএন: 
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 living-expense-table">
            <div class="row bt bb bl">
                <div class="col-sm-1 text-center br">ক্রমিক</div>
                <div class="col-sm-7 text-center br">ব্যয়ের বিবরণ (বার্ষিক)</div>
                <div class="col-sm-2 text-center br">পরিমাণ</div>
                <div class="col-sm-2 text-center br">মন্তব্য</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">১।</div>
                <div class="col-sm-7 br">ব্যক্তিগত ও পরিবারের ভরণপোষণ খরচ</div>
                <div class="col-sm-2 br">{{data?.Food_Cloth_Expense | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Food_Cloth_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">২।</div>
                <div class="col-sm-7 br">আবাসন সংক্রান্ত ব্যয়</div>
                <div class="col-sm-2 br">{{data?.House_Expense | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.House_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৩।</div>
                <div class="col-sm-7 br">ব্যক্তিগত যানবাহন সংক্রান্ত ব্যয়</div>
                <div class="col-sm-2 br">{{data?.Transportation_Expense | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Transportation_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৪।</div>
                <div class="col-sm-7 br">ইউটিলিটি সংক্রান্ত ব্যয় (বিদ্যুৎ বিল, গ্যাস, পানি, টেলিফোন, মোবাইল, ইন্টারনেট ইত্যাদি)</div>
                <div class="col-sm-2 br">{{data?.Household_Utility_Expense | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Household_Utility_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৫।</div>
                <div class="col-sm-7 br">শিক্ষা ব্যয়</div>
                <div class="col-sm-2 br">{{data?.Child_Edu_Expense | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Child_Edu_Expense}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৬।</div>
                <div class="col-sm-7 br">নিজ খরচে দেশে ও বিদেশ ভ্রমণ, অবকাশ ইত্যাদি সংক্রান্ত ব্যয়</div>
                <div class="col-sm-2 br">{{data?.domesticTravel | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.commentForDomestic}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৭।</div>
                <div class="col-sm-7 br">উৎসব ও অন্যান্য বিশেষ ব্যয়</div>
                <div class="col-sm-2 br">{{data?.otherAllWithoutDomestic + data?.Other_Expense | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{festivalSpecialExpenseComment}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৮।</div>
                <div class="col-sm-7 br">উৎসে কর্তিত/ সংগৃহীত কর (সঞ্চয়পত্রের মুনাফার উপর কর্তিত করসহ) ও বিগত বৎসরে রিটার্নের ভিত্তিতে প্রদত্ত আয়কর ও সারচার্জ</div>
                <div class="col-sm-2 br">{{ Tax_Surcharge_Payment_and_tax_at_source + data?.Tax_Environmental_Surcharge | formatNumberReturnView }}</div>
                <div class="col-sm-2 br">{{taxChargesComment}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-1 text-center br">৯।</div>
                <div class="col-sm-7 br">প্রাতিষ্ঠানিক ও অন্যান্য উৎস হতে গৃহীত ব্যক্তিগত ঋণের সুদ পরিশোধ</div>
                <div class="col-sm-2 br">{{data?.Tax_Interest_Payment_Personal_Loan | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Tax_Interest_Payment_Personal_Loan}}</div>
            </div>
            <div class="row bb bl">
                <div class="col-sm-8 text-center br">মোট</div>                
                <div class="col-sm-2 br">{{data?.Expense_Tax_Total | formatNumberReturnView}}</div>
                <div class="col-sm-2 br">{{data?.comments?.Expense_Tax_Total}}</div>
            </div>
        </div>
    </div>
    <div style="margin-top:80px" class="text-center">
        <u class="font-weight-bold">
            প্রতিপাদন
        </u>
    </div>
    <div class="row my-3">
        আমি ঘোষণা করিতেছি যে, আইটি-১০বিবি (২০২৩) তে প্রদত্ত তথ্য আমার জ্ঞান ও বিশ্বাসমতে সঠিক ও সম্পূর্ণ।
    </div>
    <div class="row" style="margin-top: 50px;">
        <div class="col-6"></div>
        <div class="col-6 text-center">
            {{returnData?.profileData?.assesName}} <br>
            {{dateAfterSign}} <br>
            স্বাক্ষর ও তারিখ
            <div class="font-italic font-weight-bold">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই। </div>            
        </div>
    </div>
</div>
